import styled, { css } from 'styled-components';

export const Styled = styled.div`

    /* position: absolute;
    top: 20%;
    right: 35px;
    z-index: 1; */

    .option-row {
        .name-col {
            display: flex;
            max-width: calc(100% - 16px);
            align-items: center;
        }

        .icon-edit-col {
            display: flex;
            flex: 1 1 16px;
            align-items: center;
            justify-content: flex-end;

            .icon__edit {
                font-size: 0.9rem;
                color: rgba(0, 0, 0, 45%);
                transition: color 0.2s;
        
                &:hover {
                    color: #1890ff;
                    cursor: pointer;
                }
            }
        }
    }

   
`;

export const ContactSelectDropdownStyled = css`

    .contact-select-dropdown {
        .ant-select-item-option-content {
            .option-row {
                height: 55px;

                .name-col {
                    display: flex;
                    overflow: hidden;
                    font-weight: 500;
                    line-height: 145%;
                    color: #141414;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                
                .detail-col {
                    overflow: hidden;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 145%;
                    color: #595959;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    .ant-tooltip-open {
                        font-size: 12px;
                    }
                }
            }
        }
    }
`;
